import type { Day, Expedition } from '../api.js';
import { Loading, Page, useApi } from '../components.js';
import { href } from '../router.js';

interface Summary { expedition: Expedition; days: Day[]; members: { name: string; role: string }[]; counts: Record<string, number> }

export function ExpeditionPage({ exp }: { exp: string }) {
  const { data, error } = useApi<Summary>(`/api/expeditions/${exp}`);
  if (!data) return <Page title="Expedition" back={{ href: href.home(), label: 'Expeditions' }}><Loading error={error} /></Page>;
  const e = data.expedition;
  return (
    <Page title={e.title} back={{ href: href.home(), label: 'Expeditions' }}>
      <p className="muted">{e.startDate} → {e.endDate} · {data.members.map((m) => m.name).join(', ')}</p>
      <nav className="tabs">
        <a href={href.gaps(exp)}>Gap list</a>
        <a href={href.review(exp)}>Review</a>
        <a href={href.settings(exp)}>Settings</a>
        <a href={`/api/expeditions/${exp}/export`}>Export JSON</a>
      </nav>
      <p className="counts">{Object.entries(data.counts).map(([k, n]) => `${n} ${k}`).join(' · ')}</p>
      <ol className="days">
        {data.days.map((d) => (
          <li key={d.id}>
            <a href={href.day(exp, d.id)}><strong>{d.id}</strong> {d.title}</a>
            <span className="muted"> {d.date}{d.ridingDay ? ` · riding day ${d.ridingDay}` : ''}</span>
          </li>
        ))}
      </ol>
    </Page>
  );
}
